// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-method-switcher {
  --switcher-border-radius: 5px;
  overflow-x: hidden;
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.payment-method-switcher .method {
  background: var(--white);
  border: 2px solid transparent;
  border-radius: var(--switcher-border-radius);
  font-weight: 500;
  font-size: 14px;
  height: 67px;
  min-height: 67px;
  min-width: 49%;
  max-width: 49%;
  overflow-x: hidden; /* to hide paypal button*/

  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  cursor: pointer;

  color: var(--black);
}

@keyframes apple-pay-tab {
  0% {
    opacity: 0.2;
    transform: translateX(-80px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.payment-method-switcher .method.apple-pay {
  transition: none;
  animation-name: apple-pay-tab;
  -webkit-animation-name: apple-pay-tab;
  animation-timing-function: ease-in-out;
  animation-duration: 0.4s;
}

.payment-method-switcher.with-apple-pay .method {
  min-width: auto;
  width: 32%;
  max-width: 32%;
}

@media (min-width: 375px) {
  .payment-method-switcher.with-apple-pay .method {
    min-width: 105px;
  }
}

.payment-method-switcher .method.selected {
  background: white;
  background: var(--very-light-orange);
  border-color: var(--orange);
}

.payment-method-switcher .method.apple-pay .stripe-wallet-container {
  width: 100%;
}

.payment-method-switcher .method.paypal svg {
  width: 80%;
  max-width: 100px;
}

.payment-method-switcher .method.credit-card {
  flex-direction: column;
  padding: 0 13px;
}

.payment-method-switcher .payment-method-icons {
  margin-top: 9px;

  gap: 4px;
  justify-content: space-between;
  padding-top: 1px;
}

.payment-method-switcher .payment-method-icons .icon-container {
  width: 26px;
  height: 18px;
  border: 0.5px solid var(--purple-blue);
  border-radius: 1.5px;
}

.payment-method-switcher .payment-method-icons .icon-container svg {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

.payment-method-switcher .payment-method-icons .master-card svg {
  width: 16px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.payment-method-switcher.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB,EAAE,yBAAyB;;EAE7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;;EAEZ,eAAe;;EAEf,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;;EAEf,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".payment-method-switcher {\n  --switcher-border-radius: 5px;\n  overflow-x: hidden;\n  display: flex;\n  margin-bottom: 16px;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n}\n\n.payment-method-switcher .method {\n  background: var(--white);\n  border: 2px solid transparent;\n  border-radius: var(--switcher-border-radius);\n  font-weight: 500;\n  font-size: 14px;\n  height: 67px;\n  min-height: 67px;\n  min-width: 49%;\n  max-width: 49%;\n  overflow-x: hidden; /* to hide paypal button*/\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n\n  cursor: pointer;\n\n  color: var(--black);\n}\n\n@keyframes apple-pay-tab {\n  0% {\n    opacity: 0.2;\n    transform: translateX(-80px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.payment-method-switcher .method.apple-pay {\n  transition: none;\n  animation-name: apple-pay-tab;\n  -webkit-animation-name: apple-pay-tab;\n  animation-timing-function: ease-in-out;\n  animation-duration: 0.4s;\n}\n\n.payment-method-switcher.with-apple-pay .method {\n  min-width: auto;\n  width: 32%;\n  max-width: 32%;\n}\n\n@media (min-width: 375px) {\n  .payment-method-switcher.with-apple-pay .method {\n    min-width: 105px;\n  }\n}\n\n.payment-method-switcher .method.selected {\n  background: white;\n  background: var(--very-light-orange);\n  border-color: var(--orange);\n}\n\n.payment-method-switcher .method.apple-pay .stripe-wallet-container {\n  width: 100%;\n}\n\n.payment-method-switcher .method.paypal svg {\n  width: 80%;\n  max-width: 100px;\n}\n\n.payment-method-switcher .method.credit-card {\n  flex-direction: column;\n  padding: 0 13px;\n}\n\n.payment-method-switcher .payment-method-icons {\n  margin-top: 9px;\n\n  gap: 4px;\n  justify-content: space-between;\n  padding-top: 1px;\n}\n\n.payment-method-switcher .payment-method-icons .icon-container {\n  width: 26px;\n  height: 18px;\n  border: 0.5px solid var(--purple-blue);\n  border-radius: 1.5px;\n}\n\n.payment-method-switcher .payment-method-icons .icon-container svg {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n\n.payment-method-switcher .payment-method-icons .master-card svg {\n  width: 16px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
